<template>
  <div>
    <div v-if="message" class="alert d-flex align-items-center alert-dismissable alert-danger" role="alert">
      <div class="flex-00-auto">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="flex-fill ml-3">
        <p class="mb-0" v-html="message"></p>
      </div>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="row">
      <div class="col-12" v-if="!$_.isEmpty(package)">
        <div class="block">
          <div class="block-content">
            <div class="row items-push">
              <div class="col-md-4 col-lg-6">
                <div class="row gutters-tiny h-100">
                  <div class="col-12 mb-3 d-flex justify-content-center align-items-center">
                    <a class="img-link img-link-zoom-in img-lightbox" href="/media/mascot.png" target="_blank">
                      <img class="img-fluid" src="/media/mascot.png" :alt="package.name" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-lg-6">
                <div class="d-flex justify-content-between align-items-center border-bottom mb-2">
                  <div class="font-size-h2 font-w700 py-2">
                    {{ package.name }}
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center border-bottom mb-2">
                  <div class="font-size-h2 font-w700 pb-2">
                    <span class="text-muted mr-2"
                      ><del>{{ $_.sumBy(package.sites, 'price') | currency }}</del></span
                    >
                    <span class="text-success">&euro;{{ package.price }}</span>
                  </div>
                </div>
                <p>{{ package.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="block">
          <div class="block-header block-header-default">
            <h3 class="block-title" v-if="$_.isEmpty(package)">Multi links toevoegen</h3>
            <h3 class="block-title" v-else>Linkpakket instellen</h3>
            <div class="block-options">
              <label for="file-upload" class="btn btn-outline-secondary"> <i class="fas fa-file-upload mr-1"></i> importeer sheet </label>
              <input ref="fileUpload" id="file-upload" type="file" v-on:change="importSheet" />
            </div>
          </div>
          <div class="block-content">
            <div class="table-responsive">
              <table class="table table-striped table-vcenter">
                <thead>
                  <tr>
                    <th width="175px">Startpagina</th>
                    <th width="150px">Pagina</th>
                    <th width="150px">Categorie</th>
                    <th style="min-width: 150px">
                      Titel
                      <i
                        class="fas fa-question-circle ml-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Geen Adult links toegestaan"
                        data-original-title="Geen Adult links toegestaan"
                      ></i>
                    </th>
                    <th style="min-width: 150px">Url</th>
                    <th style="min-width: 150px">Start datum</th>
                    <th v-if="$_.isEmpty(package)" width="110px">Prijs</th>
                    <th class="text-center" width="80px" v-if="$_.isEmpty(package)">Acties</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(link, index) in links">
                    <bs-link-import-table-item
                      v-if="!link.removed"
                      :key="index"
                      :link="link"
                      :sites="sites"
                      :index="index"
                      :added="added[index]"
                      :errors="errors[index]"
                      :package="package"
                      @removeRow="removeRow"
                    ></bs-link-import-table-item>
                  </template>
                </tbody>
              </table>
            </div>
            <div class="form-group" v-if="$_.isEmpty(package)">
              <button type="button" class="btn btn-success" :disabled="links.length >= 100" v-on:click.prevent="addRow">
                <i class="fas fa-plus"></i>
              </button>
            </div>
            <div class="form-group text-right">
              <button type="submit" class="btn btn-primary" v-on:click.prevent="submit" :disabled="loading">Toevoegen</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import EventBus from '../plugins/vue-event-bus';
import axios from 'axios';

export default {
  props: {
    sites: {
      type: Array,
      required: true,
      default: () => [],
    },
    package: {
      type: Object,
      required: false,
      default: () => {},
    },
    user_package: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data: () => {
    return {
      links: [],
      added: [],
      errors: [],
      message: null,
      loading: false,
      translations: {
        site_id: 'Startpagina',
        page_id: 'Pagina',
        category_id: 'Categorie',
        title: 'Titel',
        url: 'Url',
      },
    };
  },
  created: function() {
    let storage = localStorage.getItem('links');
    if (this.user_package) {
      storage = localStorage.getItem(this.user_package.id);
    }

    if (storage && JSON.parse(storage).expires_at >= moment().toISOString()) {
      this.links = JSON.parse(storage).links;
    } else if (!_.isEmpty(this.package)) {
      this.package.sites.forEach((site, index) => {
        this.links.push({
          site_id: site.site.id,
          page_id: site.page_id,
          category_id: null,
          title: null,
          url: null,
          start_date: moment().format('YYYY-MM-DD'),
          removed: false,
        });
      });
    } else {
      for (let index = 0; index < 5; index++) {
        this.links.push({
          site_id: null,
          page_id: null,
          category_id: null,
          title: null,
          url: null,
          start_date: moment().format('YYYY-MM-DD'),
          removed: false,
        });
      }
    }
  },
  watch: {
    links: {
      deep: true,
      handler: function() {
        localStorage.setItem(
          this.user_package ? this.user_package.id : 'links',
          JSON.stringify({
            expires_at: moment()
              .add(1, 'hour')
              .toISOString(),
            links: this.links,
          })
        );
      },
    },
  },
  methods: {
    importSheet: function(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);

      this.message = null;

      axios
        .post(route('links.excel'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.links = response.data.data;
            if (response.data.errors) {
              let errors = {};

              Object.keys(response.data.errors).map((indexKey) => {
                let errorObject = response.data.errors[indexKey];
                let match = indexKey.match(/\D*\.(\d+)\.(\D*)/i);
                Object.values(errorObject).map((error) => {
                  errors[`${match[1]}_${match[2]}`] = [error.toLowerCase().replace(match[0], match[2])];
                });

                this.$set(this.errors, match[1], errors);
              });
            }
          } else {
            this.message = response.data.message;
          }
        })
        .finally(() => {
          this.$refs.fileUpload.value = '';

          setTimeout(() => {
            window.One.helpers(['select2', 'maxlength', 'flatpickr']);
          }, 100);
        });
    },
    addRow: function() {
      if (this.links.length < 100) {
        this.links.push({
          site_id: null,
          page_id: null,
          category_id: null,
          title: null,
          url: null,
          start_date: moment().format('YYYY-MM-DD'),
          removed: false,
        });
        setTimeout(() => {
          window.One.helpers(['select2', 'maxlength', 'flatpickr']);
        }, 100);
      }
    },
    removeRow: function(index) {
      this.$set(this.links, index, {
        ...this.links[index],
        removed: true,
      });
    },
    submit: function() {
      this.loading = true;
      let errors = this.links.filter((link, index) => {
        if (link.removed) return false;

        let emptyValues = Object.values(link).filter((x) => x === null || x === '');
        let errors = {};

        if (emptyValues.length > 0) {
          // Not valid stop
          if (emptyValues.length !== Object.keys(link).length) {
            // Kan ook weg!
            Object.keys(link).forEach((key) => {
              let value = link[key];
              if (value === null || value == '') {
                errors[`${index}_${key}`] = [`${this.translations[key]} is verplicht`];
              }
            });
          }
        }

        this.$set(this.errors, index, errors);
        return emptyValues.length > 0;
      });

      if (errors.length === 0) {
        // Add to Cart
        axios
          .post(route('cart.import'), {
            links: this.links
              .filter((link) => {
                return !link.removed;
              })
              .map((link) => {
                return {
                  site_id: link.site_id,
                  link_id: null,
                  page_id: link.page_id,
                  category_id: link.category_id,
                  title: link.title,
                  url: link.url,
                  description: null,
                  follow: true,
                  start_date: link.start_date,
                  period: link.page_id != 1 ? 200 : 1,
                  user_package_id: !_.isEmpty(this.user_package) ? this.user_package.id : null,
                };
              }),
          })
          .then((response) => {
            if (response.status == 200 && response.data) {
              if (response.data.errors) {
                let errors = {};

                Object.keys(response.data.errors).map((indexKey) => {
                  let errorObject = response.data.errors[indexKey];
                  let match = indexKey.match(/[a-z]*\.(\d+)\.([a-z]*)/i);
                  Object.values(errorObject).map((error) => {
                    errors[`${match[1]}_${match[2]}`] = [error.toLowerCase().replace(match[0], match[2])];
                  });

                  this.$set(this.errors, match[1], errors);
                });
              }

              if (response.data.success) {
                EventBus.publish('cart.refresh');
                localStorage.removeItem('links');
                if (!_.isEmpty(this.user_package)) {
                  this.$notify({
                    group: 'main',
                    type: 'success',
                    title: `Linkpakket ${this.package.name} is toegevoegd en staat in de winkelwagen klaar voor betaling`,
                  });
                  window.location = route('cart.index');
                } else {
                  this.$notify({
                    group: 'main',
                    type: 'success',
                    title: `De links (${response.data.data.length}) zijn toegevoegd en staan in de winkelwagen klaar voor betaling`,
                  });
                  window.location = route('cart.index');
                }

                response.data.data.forEach((link, index) => {
                  this.$set(this.added, index, true);
                });
              }

              this.loading = false;
            }
          });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
input[type='file'] {
  display: none;
}

@media (min-width: 992px) {
  table {
    table-layout: fixed;
  }
}
</style>
